import React from 'react';

const Cloud = (props) => {
  const { info } = props;

  return (
    <img
      src={`https://www.weatherbit.io/static/img/icons/${info.icon}.png`}
      className={info.class}
      alt="cloud"
    />
  );
};

export default Cloud;
